module.exports = __webpack_public_path__ + "img/profile_label_vod.b93daffb.png";